import { render, staticRenderFns } from "./VerificationsAssignPartner.vue?vue&type=template&id=44a11988&"
import script from "./VerificationsAssignPartner.vue?vue&type=script&lang=js&"
export * from "./VerificationsAssignPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports